import {useAuth} from '../../contexts/AuthContext';
import {Box, Typography, Link, Paper, Stack, Divider, IconButton} from '@mui/material';
import { Navigate } from 'react-router-dom';
import { Email, Chat } from '@mui/icons-material';

const Profile = () => {
  const {currentUser} = useAuth();

  if(!currentUser) {
      return <Navigate to='/login'/>
  }
  return (
    <Box sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: 'bold', color: 'primary.main' }}>
          Your Profile
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ color: 'text.secondary', mb: 1 }}>
            Email
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
            {currentUser.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box>
          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', mb: 3 }}>
            Support & Contact
          </Typography>

          <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
            We're committed to providing the best test preparation experience across multiple standardized tests. I'm trying my best to be available 24/7 if you find any issues or need assistance.
          </Typography>

          <Stack spacing={2}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <IconButton 
                color="primary" 
                component={Link} 
                href="mailto:ahnyuofm@gmail.com"
                sx={{ bgcolor: 'primary.light', '&:hover': { bgcolor: 'primary.main' } }}
              >
                <Email />
              </IconButton>
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Email Support
                </Typography>
                <Link href="mailto:ahnyuofm@gmail.com" sx={{ color: 'text.secondary', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
                  ahnyuofm@gmail.com
                </Link>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <IconButton 
                color="primary" 
                component={Link} 
                href="https://discord.gg/Rbw93bBX"
                target="_blank"
                sx={{ bgcolor: 'primary.light', '&:hover': { bgcolor: 'primary.main' } }}
              >
                <Chat />
              </IconButton>
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Discord Community
                </Typography>
                <Link 
                  href="https://discord.gg/Rbw93bBX" 
                  target="_blank"
                  sx={{ color: 'text.secondary', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                >
                  Join our Discord server
                </Link>
              </Box>
            </Box>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
};

export default Profile;